export const PRODUCT = 'NURSING CLINICAL SKILLS VISUAL ATLAS™'

export const PRODUCT_TAGLINE =
  'THE COMPLETE PROFESSIONAL NURSING CLINICAL SKILLS & PROCEDURES VISUAL SYSTEM'

/** Anchor id of the $27 purchase section */
export const OFFER_ANCHOR = '#offer'

export const CHECKOUT_URL =
  'https://nursing-clinical-skills-visual-atlas.impultienda.ar/checkout'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/cYrRPgwAMJ4uYT7tFAms6n/Diseno_sin_titulo-6.png'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1086781087036952'
